import React, { Fragment } from 'react';
import logo from './logo.svg';
import './App.css';
import About from './About.js';
import Contact from './Contact.js';
import Nav from 'react-bootstrap/Nav';
import Portfolio from './Portfolio.js';
import Card from 'react-bootstrap/Card';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import CardColumns from 'react-bootstrap/CardColumns';


function App() {
  return (
    <div className="App">
    <Navbar collapseOnSelect expand="lg" bg="primary" variant="dark" >
      <Navbar.Brand href=" " style={{fontSize: '24px'}}>Bienvenidos Amigos</Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mr-auto">
        </Nav>
        <Nav>
          <Nav.Link href="#portfolio" style={{color: '#fff', fontSize: '20px'}}>Portfolio</Nav.Link>
          <Nav.Link href="#contact" style={{color: '#fff', fontSize: '20px'}}>Contact</Nav.Link>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
      <About/>
      <Portfolio/>
      <Contact/>

      <h6 style={{color: '#333', marginTop:70, marginBottom:50}}>&copy; Copyright 2021 | Priyanka Roy | All Rights Reserved</h6>
    </div>
  );
}

export default App;
